<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div>
    <custom-events-targeting-editor
      :selected-custom-events="selectedCustomEvents"
      :is-from-package="false"
      :can-be-removed="canBeRemoved"
      @changed="onChanged"
      @cleared="clear" />
  </div>
</template>

<script type="text/babel">
  import { mapActions } from 'vuex';

  import CustomEventsTargetingEditor from '@/common/components/controls/targeting/customEvents/CustomEventsTargetingEditor';
  import CreativeTargetingCriterion from '@/common/models/creative/CreativeTargetingCriterion';
  import { useTargetingCriteria } from '@/org-app/services/tanstack/queries';
  import { waitForPendingQueries } from '@/org-app/services/tanstack/queryUtils';

  export default {
    components: {
      CustomEventsTargetingEditor,
    },
    props: {
      creative: {
        type: Object,
      },
      canBeRemoved: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        targetingCriteriaQuery: useTargetingCriteria(),
      };
    },
    computed: {
      targetingCriteria() {
        return this.targetingCriteriaQuery.items;
      },
      selectedCustomEvents() {
        if (this.creative == null) {
          return [];
        }
        const externalTargetingCriteria = this.targetingCriteria.filter((x) => x.isUpdatePushedExternally);
        const customEventCriteria = this.creative.creativeTargetingCriteria.filter((x) =>
          externalTargetingCriteria.some((etc) => etc.id === x.targetingCriterionID),
        );
        const selectedCustomEvents = externalTargetingCriteria
          .map((etc) => etc.subTypes)
          .flat()
          .filter((x) => customEventCriteria.some((y) => y.values.some((z) => z.code === x.code)));
        return selectedCustomEvents;
      },
    },
    async beforeMount() {
      await waitForPendingQueries([this.targetingCriteriaQuery]);
    },
    methods: {
      ...mapActions(['updateCreativeTargetingCriteria']),
      onChanged(customEvents) {
        const externalTargetingCriteria = this.targetingCriteria.filter((x) => x.isUpdatePushedExternally);
        const otherTargetingCriteria = this.creative.creativeTargetingCriteria.filter(
          (x) => !externalTargetingCriteria.some((etc) => etc.id === x.targetingCriterionID),
        );
        const value = [
          ...(otherTargetingCriteria == null ? [] : otherTargetingCriteria),
          ...externalTargetingCriteria.map(
            (etc) =>
              new CreativeTargetingCriterion(
                this.creative.id,
                etc.id,
                customEvents.map((x) => {
                  return {
                    code: x.code,
                    value: 'DUMMY',
                  };
                }),
              ),
          ),
        ];

        this.updateCreativeTargetingCriteria({
          creative: this.creative,
          value,
        });
        this.$emit('changed', customEvents);
      },
      clear() {
        this.updateCreativeTargetingCriteria({
          creative: this.creative,
          value: [],
        });
        this.$emit('cleared');
      },
    },
  };
</script>
